import {
    Component,
    OnInit,
  } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { arrayUnion, updateDoc } from "firebase/firestore";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { environment } from "src/environments/environment";

  

@Component({
    selector: "component-carica-verbale_fase3",
    templateUrl: "./dialog-carica_verbale_fase3.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogCaricaVerbaleFase3Firmato implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected tipoDoc:String="";
    
    protected file: File;
    protected verbaliFirmati: File[] = [];
    protected isUploadingDoc:boolean = false;
    protected isTipoD:boolean = false;
    protected richiedeDueVerbali: boolean = false;
    
    protected label:string="Cerca il VERBALE FIRMATO" ;
    protected icona:string="";
    protected stile:string="btn-choose-file-preventivo";
    protected fileClass:string="btn-choose-file-preventivo";
    protected acceptedFileTypes:string=".pdf";
    protected displayFileName:string="";

    protected areFileUploaded: boolean = false;

    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      public firestore: AngularFirestore,
    ) {
      this.pratica          = this.config.data.pratica;
      if(this.pratica.tipoSedeEffettiva.endsWith('D')){
        this.isTipoD = true;
      }
      this.richiedeDueVerbali =
        this.config.data && typeof this.config.data.richiedeDueVerbali === "boolean"
          ? this.config.data.richiedeDueVerbali
          : this.isTipoD;
    }
  
    ngOnInit(): void {
    }

    onFileUpload($event){
      if(this.richiedeDueVerbali){
        this.logger.info("VERBALI FIRMATI");
        this.logger.info($event.files);
        this.logger.info($event.files.length);
        
          if($event.files.length > 1){
            this.areFileUploaded = true;
            this.verbaliFirmati = $event.files;
            this.icona = "pi pi-check";
            this.fileClass = "btn-preventivo-upload-success";
            this.areFileUploaded = true;
          // this.label = 'Verbali FIRMATI caricati';
            //this.displayFileName = `Verbale Fase 3 - ${this.pratica.cui}`;
          }
       /*  
        this.displayFileName = `Verbale Fase 3 - ${this.pratica.cui}`;
        this.icona = "pi pi-check";
        this.fileClass = "btn-preventivo-upload-success";
        this.file = $event.files[0]; */
      }else{
       // this.label = 'Verbale FIRMATO caricato';
        //this.displayFileName = `Verbale Fase 3 - ${this.pratica.cui}`;
        this.icona = "pi pi-check";
        this.fileClass = "btn-preventivo-upload-success";
        this.file = $event.files[0];
        this.areFileUploaded = true;
      }
    }

    onFileSelect($event: { files: File[]; }) {
      if(this.richiedeDueVerbali){
        this.logger.info("VERBALI FIRMATI");
        this.logger.info($event.files);
        this.logger.info($event.files.length);
        if($event.files.length > 1){
          this.areFileUploaded = true;
          this.verbaliFirmati = $event.files;
          this.icona = "pi pi-check";
          this.fileClass = "btn-preventivo-upload-success";
          this.areFileUploaded = true;
          this.label = 'Verbali FIRMATI caricati';
        }
       /*  
        this.displayFileName = `Verbale Fase 3 - ${this.pratica.cui}`;
        this.icona = "pi pi-check";
        this.fileClass = "btn-preventivo-upload-success";
        this.file = $event.files[0]; */
      }else{
        this.label = 'Verbale FIRMATO caricato';
        this.displayFileName = `Verbale Fase 3 - ${this.pratica.cui}`;
        this.icona = "pi pi-check";
        this.fileClass = "btn-preventivo-upload-success";
        this.file = $event.files[0];
        this.areFileUploaded = true;
      }
    
    //  this.logger.info(this.file);
    }  

   
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        if(this.richiedeDueVerbali){
          if (this.verbaliFirmati.length < 2){
            this.messageService.add({
              severity: "info",
              summary: "Errore" , life:10000,
              detail: "Devono essere caricati due verbali firmati!",
            });
            //this.dialogRef.close({ success: false });
          }else{
            const promises: Promise<void>[] = [];
            const promise = new Promise<void>((resolve, reject) => {
              this.verbaliFirmati.forEach(file =>{
                const fileExtension = file.name.substring(
                  file.name.lastIndexOf(".") + 1
                );
                const fileName = this.pratica.cui + "/OUT/FASE3/SIGNED/"+file.name;
                  this.googleStorageService
                  .uploadFileScuolaToGoogleStorage(file, fileName)
                  .then((uploadRes) => {

                    resolve();
                    promises.push(promise); 
                  })
                  .catch((errore) => {
                    
                    reject();
                    promises.push(promise); 
                  });
                  
              });
            });
            Promise.all(promises).then(() => {
              this.dialogRef.close({ success: true});
            }).catch((error) => {
              this.logger.error("Errore durante l'esecuzione delle promesse:", error);
              this.messageService.add({
                            severity: "info",
                          summary: "Errore" , life:10000,
                            detail: "Errore in fase di caricamento Verbali Firmati!",
                          });
              this.dialogRef.close({ success: false});
            
            });
          }
              
        }else{
          const fileExtension = this.file.name.substring( this.file.name.lastIndexOf(".") + 1);
          const fileName = this.pratica.cui + "/OUT/FASE3/SIGNED/"+this.file.name;
           this.googleStorageService
            .uploadFileScuolaToGoogleStorage(this.file, fileName)
            .then((uploadRes) => {
              this.dialogRef.close({ success: true });
            })
            .catch((errore) => {
              this.messageService.add({
                severity: "info",
               summary: "Errore" , life:10000,
                detail: "Errore in fase di caricamento File!",
              });
    
              this.dialogRef.close({ success: false });
            });
        }
        

        
       
      } 
    }
  
  }